import React from 'react';
import { Box, Text } from '@wix/design-system';
import { GiftSmall } from '@wix/wix-ui-icons-common';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import s from './perceptionNote.module.scss';
const ICON_GAP = {
  inline: '4px',
  bullet: '10px'
};
export const PerceptionNote = _ref => {
  let {
    labelKey,
    values,
    withIcon = false,
    size = 'tiny',
    variant = 'inline',
    dataHook = 'perception-note'
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, {
    className: s.note,
    direction: "horizontal",
    gap: ICON_GAP[variant],
    verticalAlign: "middle",
    dataHook: dataHook
  }, withIcon && /*#__PURE__*/React.createElement(Box, {
    className: s.icon
  }, /*#__PURE__*/React.createElement(GiftSmall, {
    color: "var(--wds-color-text-standard-primary)"
  })), /*#__PURE__*/React.createElement(Text, {
    size: size,
    weight: "normal"
  }, t(labelKey, values)));
};
//# sourceMappingURL=PerceptionNote.js.map